import { createSelector, select } from '@ngrx/store';

import { safeSelect, StateSelector } from '@fcom/core/selectors/selector-utils';
import { HistogramBar } from '@fcom/common';

import { BookingWidgetState, CalendarPrices, InstantSearchMonitoring, WidgetTab } from '../../interfaces';
import { BookingWidgetAppState, bookingWidgetFeatureState } from './booking-widget-feature-state.selector';

const _bookingWidgetState = createSelector(
  bookingWidgetFeatureState,
  (_bs: BookingWidgetAppState) => _bs?.bookingWidget
);

export const _instantSearchMonitoringSelector = createSelector(
  _bookingWidgetState,
  (_bw: BookingWidgetState) => _bw?.instantSearchMonitoring
);

const _fullYearPrices = createSelector(_bookingWidgetState, (bw: BookingWidgetState) => bw?.prices?.fullYear ?? {});
const _followingMonthPrices = createSelector(
  _bookingWidgetState,
  (bw: BookingWidgetState) => bw?.prices?.followingMonth ?? {}
);
const _histogramPrices = createSelector(_bookingWidgetState, (bw: BookingWidgetState) => bw?.prices?.histogram ?? []);
export const selectAirCalendarPrices = createSelector(
  _bookingWidgetState,
  (bw: BookingWidgetState) => bw?.prices?.airCalendar
);

export const selectNotificationWarnings = createSelector(
  _bookingWidgetState,
  (bw: BookingWidgetState) => bw?.warnings ?? {}
);

export const selectActiveTab = createSelector(
  _bookingWidgetState,
  (bw: BookingWidgetState) => bw?.activeTab ?? WidgetTab.FLIGHT
);

export const instantSearchMonitoring = (): StateSelector<BookingWidgetAppState, InstantSearchMonitoring> =>
  safeSelect(_instantSearchMonitoringSelector);

export const fullYearPrices = (): StateSelector<BookingWidgetAppState, CalendarPrices> => select(_fullYearPrices);
export const followingMonthPrices = (): StateSelector<BookingWidgetAppState, CalendarPrices> =>
  select(_followingMonthPrices);
export const histogramPrices = (): StateSelector<BookingWidgetAppState, HistogramBar[]> => select(_histogramPrices);
